import api from "@/lib/api";

export const isVideo = (f) => (f.type || "").startsWith("video/") || /\.(mov|mp4|m4v|3gp)$/i.test(f.name);

export const fmtDuration = (s) => {
  if (!s) return "";
  const t = Math.round(s);
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`;
};

const grabFrame = (file) => new Promise((resolve) => {
  const url = URL.createObjectURL(file);
  const v = document.createElement("video");
  let done = false;
  const finish = (blob) => {
    if (done) return;
    done = true;
    const d = Number.isFinite(v.duration) ? v.duration : 0;
    URL.revokeObjectURL(url);
    resolve({ blob, duration: d });
  };
  setTimeout(() => finish(null), 10000);
  v.muted = true;
  v.playsInline = true;
  v.preload = "metadata";
  v.onloadedmetadata = () => { v.currentTime = Math.min(1, (v.duration || 0) / 2); };
  v.onseeked = () => {
    try {
      const c = document.createElement("canvas");
      c.width = v.videoWidth;
      c.height = v.videoHeight;
      if (!c.width) { finish(null); return; }
      c.getContext("2d").drawImage(v, 0, 0);
      c.toBlob((b) => finish(b), "image/jpeg", 0.85);
    } catch { finish(null); }
  };
  v.onerror = () => finish(null);
  v.src = url;
});

const putChunk = async (id, i, part) => {
  for (let a = 0; ; a++) {
    try {
      await api.put(`/photos/${id}/chunk/${i}`, part, { headers: { "Content-Type": "application/octet-stream" } });
      return;
    } catch (e) {
      if (a >= 2 || (e.response && e.response.status < 500)) throw e;
      await new Promise((r) => setTimeout(r, 2000));
    }
  }
};

export async function uploadVideo(gid, file, onProgress) {
  const { blob, duration } = await grabFrame(file);
  const { data } = await api.post(`/photo-galleries/${gid}/videos`, { filename: file.name, size: file.size, duration });
  for (let i = 0; i < data.chunks; i++) {
    await putChunk(data.id, i, file.slice(i * data.chunk_size, Math.min(file.size, (i + 1) * data.chunk_size)));
    onProgress(Math.round(((i + 1) / data.chunks) * 100));
  }
  const fd = new FormData();
  if (blob) fd.append("frame", blob, "frame.jpg");
  await api.post(`/photos/${data.id}/complete`, fd);
}
